export default __webpack_public_path__ + "static/media/view.8e7e265e.svg";